import { Button, Card, CardContent, Collapse, Container, Divider, FormControlLabel, Paper, Stack, Switch } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { AutoComplete, Box, TextField, Typography } from '@utilisourcepackagelibdev/utilisourcepackagelib'
import React, { FC, ReactNode, useEffect, useMemo } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import EmailEditor from './EmailEditor.component'
import { ActionConfig } from './workflowRules.interface'
import TextBox from '@/components/Molecules/Textbox/Textbox.component'
import { EmailAutocomplete } from '@/components/Organisms/EmailAutocomplete/EmailAutocomplete.component'
// import { ActionConfig } from './WorkflowRuleDrawer'
import { createStatusesByCustomerOptions } from '@/services/ticket/ticketType.options'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import Token from './Token.component'
import { createWorkflowAgentByCustomerQuery } from '@/services/agent/agent.options'


interface ConfigurationSectionProps {
  show: boolean;
  children: ReactNode;
}

const WorkflowRuleStep3 = () => {

  const methods = useFormContext()
  const { control, setValue, watch } = methods;


  // const actionsWatch = useWatch({
  //   control,
  //   name: 'actions',
  //   defaultValue: []
  // });

  // // Create derived state for each action type
  // const statusSwitchWatch = useMemo(() => {
  //   return actionsWatch.some((action: any) => action.type === 'status' && action.status_switch);
  // }, [actionsWatch]);

  // const emailSwitchWatch = useMemo(() => {
  //   return actionsWatch.some((action: any) => action.type === 'email' && action.email_switch);
  // }, [actionsWatch]);

  // const assigneeSwitchWatch = useMemo(() => {
  //   return actionsWatch.some((action: any) => action.type === 'assignee' && action.assignee_switch);
  // }, [actionsWatch]);


  const assigneeSwitchWatch = useWatch({ control, name: 'actions.assignee.assignee_switch' });
  const statusSwitchWatch = useWatch({ control, name: 'actions.status.status_switch' });
  const emailSwitchWatch = useWatch({ control, name: 'actions.email.email_switch' });

  const customerWatch = useWatch({ control, name: 'customer.id' });

  const actions = useWatch({ control, name: 'actions' }) || [];

  // const getActionConfig = (type: string) => actions.find((action: ActionConfig) => action.type === type)?.config || {};
  // const getActionEnabled = (type: string) => actions.find((action: ActionConfig) => action.type === type)?.enabled || false;

  // const updateAction = (type: string, enabled: boolean, config: Partial<ActionConfig['config']> = {}) => {
  //   const newActions = actions.filter((action: ActionConfig) => action.type !== type);
  //   if (enabled) {
  //     newActions.push({ type, enabled, config: { ...getActionConfig(type), ...config } });
  //   }
  //   setValue('actions', newActions);
  // };

  const agentsByCustomer = useSuspenseQuery(createWorkflowAgentByCustomerQuery({ customerId: customerWatch }))
  const statusesByCustomer = useSuspenseQuery(createStatusesByCustomerOptions({ customerId: customerWatch }))




  const ConfigurationSection: FC<ConfigurationSectionProps> = ({
    show,
    children
  }) => {
    return (
      <Collapse in={show}>
        <Paper sx={{ p: 2, mt: 1 }}>
          {children}
        </Paper>
      </Collapse>
    );
  };


  // const useActionIndex = (actionType: 'status' | 'email' | 'assignee') => {
  //   const { getValues } = useFormContext();

  //   return useMemo(() => {
  //     return getValues('actions')?.findIndex((a: any) => a.type === actionType);
  //   }, [getValues, actionType]);
  // };


  // const statusActionIndex = useActionIndex('status');
  // const assigneeActionIndex = useActionIndex('assignee');
  // const emailActionIndex = useActionIndex('email');

  return (
    <>
      <Grid container spacing={3}>
        {/* Status Action Card */}
        <Grid size={6}>
          <Card>
            <CardContent>
              <Stack spacing={2}>
                <Typography variant="h6">
                  Set Status
                  <Controller
                    name="actions.status.status_switch"
                    control={methods.control}
                    render={({ field: { onChange, value } }) => (
                      <FormControlLabel
                        control={
                          <Switch
                            sx={{ ml: 4 }}
                            id='status_switch'
                            color="primary"
                            onChange={(e) => onChange(e.target.checked)}
                            checked={value}
                          />
                        }
                        label=""
                      />
                    )}
                  />
                </Typography>
                <ConfigurationSection show={statusSwitchWatch}>
                  <AutoComplete
                    id={`actions.status.status_config.statusObject`}
                    label="Select Status"
                    placeholder='Select Status'
                    options={statusesByCustomer?.data?.map((status: any, index: number) => ({
                      id: status.StatusID,
                      label: status.Name,
                    })) || []}
                    loading={statusesByCustomer?.isPending}
                    autocompleteProps={{
                      id: 'action_status',
                      loadingText: 'Loading Statuses...',
                      fullWidth: true,
                      size: 'small',
                      onChange(event, value, reason, details) {
                        setValue(`actions.status.type`, 'status')
                      },
                    }}
                  />
                </ConfigurationSection>
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        {/* Assignee Action Card */}
        <Grid size={6}>
          <Card>
            <CardContent>
              <Stack spacing={2}>
                <Typography variant="h6">
                  Set Assignee
                  <Controller
                    name="actions.assignee.assignee_switch"
                    control={methods.control}
                    render={({ field: { onChange, value } }) => (
                      <FormControlLabel
                        control={
                          <Switch
                            sx={{ ml: 4 }}
                            id='assignee_switch'
                            color="primary"
                            onChange={(e) => onChange(e.target.checked)}
                            checked={value}
                          />
                        }
                        label=""
                      />
                    )}
                  />
                </Typography>
                <ConfigurationSection show={assigneeSwitchWatch}>
                  <AutoComplete
                    id={`actions.assignee.assignee_config.assigneeObject`}
                    label="Select Assignee"
                    placeholder='Select Assignee'
                    options={agentsByCustomer?.data?.map((agent: any) => ({
                      id: agent.Agentid,
                      label: agent.Name
                    })) || []}
                    loading={agentsByCustomer?.isPending}
                    autocompleteProps={{
                      id: `actions.assignee.assignee_config.Assignee`,
                      loadingText: 'Loading Assignees...',
                      fullWidth: true,
                      size: 'small',
                    }}
                  />
                </ConfigurationSection>
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        {/* Email Action Card */}
        <Grid size={12}>
          <Card>
            <CardContent>
              <Stack spacing={2}>
                <Typography variant="h6">
                  Send Email
                  <Controller
                    name="actions.email.email_switch"
                    control={methods.control}
                    render={({ field: { onChange, value } }) => (
                      <FormControlLabel
                        control={
                          <Switch
                            sx={{ ml: 4 }}
                            id='email_switch'
                            color="primary"
                            onChange={(e) => onChange(e.target.checked)}
                            checked={value}
                          />
                        }
                        label=""
                      />
                    )}
                  />
                </Typography>
                {/* <ConfigurationSection show={emailSwitchWatch}> */}
                <Collapse in={emailSwitchWatch}>
                  <Paper sx={{ p: 2, mt: 1 }}>
                    <Stack spacing={2}>
                      <EmailAutocomplete
                        control={methods.control}
                        name={`actions.email.email_config.RecipientList`}
                        options={agentsByCustomer?.data?.map((agent: any) => ({
                          id: agent.Agentid,
                          label: agent.Name
                        })) || []}
                      />
                      <TextBox
                        id={`actions.email.email_config.Subject`}
                        name={`actions.email.email_config.Subject`}
                        variant="outlined"
                        control={methods.control}
                        label="Subject"
                        size='small'
                        placeholder='Type Subject'
                        style={{ width: '100%' }}
                      />
                      <Stack direction="row" spacing={2}>
                        <Grid size={8}>

                          <EmailEditor
                            name={`actions.email.email_config.Body`}
                            control={methods.control}
                            placeHolder='Type Email Body Here...'
                            initialContent=''
                          />
                        </Grid>
                        <Grid size={4}>
                          <Token />
                        </Grid>
                      </Stack>
                    </Stack>
                  </Paper>
                </Collapse>
                {/* </ConfigurationSection> */}
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  )
}

export default WorkflowRuleStep3